export function parseAxiosErrorMessage(e) {
    var _a, _b, _c;
    let res;
    if (e.response) {
        const responseData = e.response.data;
        const responseMessage = responseData.message;
        const responseError = responseData.error;
        res = (_c = (_b = (_a = responseError === null || responseError === void 0 ? void 0 : responseError.message) !== null && _a !== void 0 ? _a : responseMessage) !== null && _b !== void 0 ? _b : responseError) !== null && _c !== void 0 ? _c : responseData;
    }
    else if (e.request) {
        res = e.request;
    }
    else {
        res = e.message;
    }
    return typeof res === 'string' ? res : e.message;
}
//# sourceMappingURL=parseAxiosErrorMessage.js.map